import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { Product } from '../../../../../../common/models/product';
import { ProductVariant } from '../models/product-detail-variant';

export class ProductSearchApi {
    constructor(protected baseUrl: string) {}

    public search(params?: URLSearchParams, abortSignal?: AbortSignal): Promise<ApiResult<PaginatedResponse<Product>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/search/products`, { params, signal: abortSignal }),
            response => {
                response.data.items = response.data.items.map(Product.fromPlainObject);
                return response.data;
            }
        );
    }

    public searchVariants(
        id: number,
        params?: URLSearchParams,
        abortSignal?: AbortSignal
    ): Promise<ApiResult<PaginatedResponse<ProductVariant>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/search-variants`, { params, signal: abortSignal }),
            response => response.data
        );
    }
}
